import { render, staticRenderFns } from "./FormHotelRoomTypes.vue?vue&type=template&id=5aa0104a&"
import script from "./FormHotelRoomTypes.vue?vue&type=script&lang=js&"
export * from "./FormHotelRoomTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aa0104a')) {
      api.createRecord('5aa0104a', component.options)
    } else {
      api.reload('5aa0104a', component.options)
    }
    module.hot.accept("./FormHotelRoomTypes.vue?vue&type=template&id=5aa0104a&", function () {
      api.rerender('5aa0104a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hotel/form/roomTypes/FormHotelRoomTypes.vue"
export default component.exports